"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('history', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }, _react.default.createElement("g", {
    transform: "translate(4.000000, 4.000000)",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth
  }, _react.default.createElement("polyline", {
    points: "1.81818182 2.72727273 1.81818182 10 9.09090909 10"
  }), _react.default.createElement("path", {
    d: "M0,20 C0,31.045695 8.954305,40 20,40 L20,40 C31.045695,40 40,31.045695 40,20 C40,8.954305 31.045695,0 20,0 C12.5979802,0 6.1351416,4.021113 2.67677036,9.99805296"
  }), _react.default.createElement("polyline", {
    transform: "translate(24.244114, 18.244114) rotate(-45.000000) translate(-24.244114, -18.244114) ",
    points: "28.490311 8.00294628 19.9979167 16.4936177 19.9979167 28.4852814"
  }))));
});

exports.default = _default;